/* Panda Food 2.0, review widget guard.

   Thirty boxer PDPs were advertising their own lack of reviews: LAI writes the
   literal string "No review" into its rating slot when a product has none, and
   an empty star row directly under the product title is worse than no star row
   at all.

   The count is decided from LAI's OWN data rather than by matching the words
   "No review", because that string is the app's copy and can change with any
   app update. The rating element carries the numbers in its
   data-rate-version2 attribute, which is the same object the theme reads for
   the aggregateRating in the page schema.

   A product that has never had a review has no metafield at all, and Liquid
   renders that as the literal string "null" into the attribute. That is the
   commonest case on the boxer range, so it has to count as zero rather than
   as unreadable, or the guard does nothing on exactly the pages it exists for.

   Runs on a MutationObserver as well as at load: LAI populates the slot after
   its own script arrives, so a single pass at DOMContentLoaded would sometimes
   hide nothing and sometimes hide it after the shopper had already seen it. */
(function () {
  var el = document.querySelector('.scm-reviews-rate');
  if (!el) return;

  function total() {
    var raw = el.getAttribute('data-rate-version2');
    if (raw === null) return null;              /* attribute absent: leave well alone */
    var s = String(raw).trim();
    /* no metafield on the product at all, so no reviews */
    if (s === '' || s === 'null' || s === '""') return 0;
    try {
      var data = JSON.parse(s);
      if (data === null) return 0;
      if (data && typeof data.total === 'number') return data.total;
    } catch (e) {}
    return null;
  }

  var n = total();
  /* null means we genuinely could not read it. Only hide on a confident zero,
     so a product WITH reviews never loses its rating to a parse failure. */
  if (n !== 0) return;

  function hide() {
    if (!el.hidden) {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
    }
  }
  hide();

  /* LAI repaints its slot when its script loads, which un-hides the element.
     Watch for that and re-apply, then stop once the page has settled. */
  if (!window.MutationObserver) return;
  var mo = new MutationObserver(hide);
  mo.observe(el, { childList: true, subtree: true, attributes: true });
  setTimeout(function () { mo.disconnect(); }, 10000);
})();
